// extracted by mini-css-extract-plugin
module.exports = {"AllIcons":"AllIcons_AllIcons__3QrSQ","AllIcons__icon":"AllIcons_AllIcons__icon__oJ2Np","bpk-keyframe-spin":"AllIcons_bpk-keyframe-spin__3PY04"};